import React from 'react';
import { Helmet } from 'react-helmet';

const PageTitle = ({ title, description, url, keywords }) => {
  // Structured data for SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "BizBridge",
    "url": `https://bizbridge.in/${url}`,
    "author": {
      "@type": "Organization",
      "name": "BizBridge"
    },
    "logo": "https://bizbridge.in/logo192.png",  
    "description": description,
    "publisher": {
      "@type": "Organization",
      "name": "BizBridge",
      "logo": {
        "@type": "ImageObject",
        "url": "https://bizbridge.in/logo192.png"
      }
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bhamashah Techno Hub, Sansthanpath, Jhalana Gram, Malviya Nagar",
      "addressLocality": "Jaipur",
      "addressRegion": "Rajasthan",
      "postalCode": "302017",
      "addressCountry": "India"
    },
    "telephone": "+91-8005968738",  
    "sameAs": [ 
       "https://www.linkedin.com/company/bizbridge-technology-private-limited"
    ]
  };

  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} /> 
      <link rel="canonical" href={`https://bizbridge.in/${url}`} />

      {/* Open Graph Meta Tags for Social Sharing */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`https://bizbridge.in/${url}`} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://bizbridge.in/logo192.png" /> 
      <meta property="og:site_name" content="BizBridge" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      
      {/* Schema.org structured data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default PageTitle;
